import { Helmet } from 'react-helmet-async';
import { filter, has } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
} from '@mui/material';
import ExcelJS from 'exceljs'
import { Link, useParams } from 'react-router-dom';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import UpdateApplication from "../layouts/form/updateForm"
import ExcelExport from './excel';
// mock
import USERLIST from '../_mock/user';


// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'Email', label: 'Email', alignRight: false },
  { id: 'Phone Number', label: 'Phone Number', alignRight: false },
  { id: 'Location', label: 'Location', alignRight: false },

  { id: 'stream', label: 'Stream', alignRight: false },
  // { id: 'YOP', label: 'year of pass', alignRight: false },
  // { id: 'Percentage', label: 'Percentage', alignRight: false },
  { id: 'Experience', label: 'Experience', alignRight: false },
  { id: 'Ctc', label: 'CTC', alignRight: false },
  { id: 'Etc', label: 'ETC', alignRight: false },
  { id: 'CurrentProject', label: 'Current Project', alignRight: false },
  { id: 'CurrentLocation', label: 'Current Location', alignRight: false },
  { id: 'LocationPrefered', label: 'Location Prefered', alignRight: false },
  { id: 'Skillset', label: 'Skillset', alignRight: false },
  { id: 'Status', label: 'Status', alignRight: false },
  { id: 'Remarks', label: 'Remarks', alignRight: false },
  { id: 'Communication', label: 'Communication', alignRight: false },
  { id: 'Joining Availability', label: 'Joining Availability', alignRight: false },
  { id: 'FirstRound', label: 'First Round', alignRight: false },
  { id: 'SecondRound', label: 'Second Round', alignRight: false },
  { id: 'resume', label: 'Resume', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  console.log(query,"qjhb")
    if (array.length === 0) {
    return [];
  }
  if (array && array.length > 0) {
  const stabilizedThis = array && array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query !="country" && query !="US" && query !="Australia") {
    return filter(array, (_user) =>
      ((_user.firstName || '').toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        (_user.lastName || '').toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        (_user.stream || '').toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        (_user.remarks || '').toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        (_user.skills || []).some(skill => skill.toLowerCase().includes(query.toLowerCase())))
    );
  }
  else if(query =="country" || query =="US" || query =="Australia"){
    console.log("enter")
    if(query =="country" ){
      return filter(array, (_user) =>
        ((_user.country || '').toLowerCase().indexOf("US".toLowerCase()) !== -1 ||
      (_user.remarks || '').toLowerCase().indexOf("Australia".toLowerCase()) !== -1


        )
      );
    }else{
      return filter(array, (_user) =>
      (
        (_user.country || '').toLowerCase().indexOf(query.toLowerCase()) !== -1
       
      
      )
    );
    }
  }
  return stabilizedThis.map((el) => el[0]);
}
return []
}

export default function UserPage() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowId,setRowId] = useState()

  const AvatarUrl =  `../../assets/images/avatars/avatar_1.jpg`


  const params = useParams()

  const [clickedIndex, setClickedIndex] = useState(-1);

  const handleClick = (index) => {
    if (clickedIndex === index) {
      setClickedIndex(-1);
    } else {
      setClickedIndex(index);
    }
  };

  const handleOpenMenu = (event,id) => {
    setRowId(id)
    setOpen(event.currentTarget);

    
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST && USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

 

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const [USERLIST,setUSERLIST] = useState([])
    useEffect(() =>{
        getApplications();
    },[]);
    const getApplications = async () =>{   
        let result = await fetch('https://careersbe.vithiit.com/getApplications',{
            headers:{
                authorization:JSON.parse(localStorage.getItem('token'))
            }
        });
        result = await result.json();
        console.log(result)
        setUSERLIST(result)
    }
    console.log("yash",USERLIST.length)

  const deleteApplicant = async (id) =>{
    console.log(id)
  let result = await fetch(`https://careersbe.vithiit.com/getdetails/${id}`,{
      method:'Delete',
      headers:{
          authorization:JSON.parse(localStorage.getItem('token'))
      }
  });
  result = await result.json();
  if(result){
    alert(`application deleted successfully`)
    getApplications();
  }
}
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);
  console.log(filteredUsers,"filtered")
  const isNotFound = !filteredUsers.length && !!filterName;
  
  useEffect(() => {
    const hashValue = window.location.hash.substr(1); // Get the hash value and remove the '#' symbol

    if (hashValue) {
      console.log(hashValue); // Output: FullStack
      setFilterName(hashValue)
    } else {
      console.log(null); // Output: null
      // Handle the case when the fragment is empty
    }
  }, []); // Empty dependency array to run the effect only once


  
  
  
  const [id,setId] = useState("")

  return (
    <>
      <Helmet>
        <title> User | Vithi IT </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Applications
          </Typography>
          <Link to="/applicationform">
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            New Application
          </Button>
          </Link>
        </Stack>

        <Card>
          <Box sx={{display:'flex',justifyContent: "flex-end" }} >
        <ExcelExport userdata={filteredUsers}/>
        </Box>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>

                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,index) => {
                    const { id,role, status, company, avatarUrl, isVerified } = row;
                    const selectedUser = selected.indexOf(id) !== -1;
                    const name = row.firstName+row.lastName

                    return (
                      <TableRow hover key={id}>
                        <TableCell >
                      
                       
                          {/* <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} /> */}
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <a href={`/applicantdetails/${row._id}`}>
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={row.firstName} src={row.profileImage} />
                            <Typography variant="subtitle2" noWrap>
                              {row.firstName} {row.lastName}
                            </Typography>
                          </Stack>
                          </a>
                        </TableCell>

                         <TableCell align="left">{row.email}</TableCell>

                        <TableCell align="left">{row.MobileNo}</TableCell>
                        <TableCell align="left">{row.country}</TableCell>

                        <TableCell align="left">{row.stream}</TableCell>

                        <TableCell align="center">{row.totalExperience}</TableCell>
                        <TableCell align="center">{row.Ctc}</TableCell>
                        <TableCell align="center">{row.Etc}</TableCell>
                        <TableCell align="center">{row.CurrentProject}</TableCell>
                        <TableCell align="center">{row.CurrentLocation}</TableCell>
                        <TableCell align="center">{row.LocationPrefered}</TableCell>

                        <TableCell align='left' onMouseEnter={() => handleClick(index)}>
                          {clickedIndex === index ? (
                            <Table>
                              <TableBody>
                                {row.skills.map((skill, index) => (
                                  <TableRow key={index}>
                                    <TableCell>{skill}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          ) : (
                            <Table>
                              <TableBody>
                                <TableRow>
                                  <Button  sx={{whiteSpace : "nowrap"}} >show skill</Button>
                                  <TableCell style={{ display: 'none' }} />
                                </TableRow>
                              </TableBody>
                            </Table>
                          )}
                        </TableCell>
                        <TableCell align="left">{row.interviewStatus}</TableCell>
                        <TableCell align="left">{row.remarks}</TableCell>
                        <TableCell align="left">{row.Communication}</TableCell>
                        <TableCell align="left">{row.DateOfav}</TableCell>


                        <TableCell align="left">{row.FirstRound}</TableCell>
                        <TableCell align="left">{row.SecondRound}</TableCell>


                        {/* <TableCell align="left">{row.DateOfav}</TableCell> */}

                        <TableCell align="left">
                          <Link target='_blank' to={row.profileResume}> <Button variant='contained'>resume</Button> </Link>
                          {/* <Label color={(status === 'banned' && 'error') || 'success'}>{sentenceCase(row.profileResume)}</Label> */}
                        </TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={(event)=>handleOpenMenu(event,row._id)}>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        
        <Link to={`/applicantdetails/${rowId}`}>
        <MenuItem >
        <Iconify icon={'eva:eye-fill'} sx={{ mr: 2 }} />
          View
        </MenuItem>
        </Link>
         <Link to={`/UpdateApplication/${rowId}`}>
        <MenuItem >
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>
        </Link>
        <MenuItem onClick={() =>deleteApplicant(rowId)} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
